import { i18n } from "@/plugins/i18n";

export class PartialPaymentReport {
  columns = [];
  id = "id";

  fillAbles = [
    ["buyContractId", i18n.t("buyContract"), true],
    ["partialPrice", i18n.t("price"), true],
    ["partialDate", i18n.t("date"), true],
    ["partialDeadline", i18n.t("deadline"), true],
    ["currentPayDate", i18n.t("paymentDate"), true],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility: true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
